import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { http } from '@/utils'
import { message } from 'antd';

class AuthorityStore {

    //数据列表初始化
    dataList = [];
    selectList = []
    selectList2 = []
    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //用户id
    jrxtid = JSON.parse(window.localStorage.getItem('jrxtid')) || ''

    //表单收集
    valueData = {}

    //弹框状态初始化
    isActive = false

    //弹框名字
    title = ''

    constructor() {
        makeAutoObservable(this)

    }
    //下拉
    getSelectList = async () => {
        const res = await http.get(`/adminapi/apigroup?page=${this.page}&limit=${this.pagesize}`)
        runInAction(() => {
            let newdata = []
            JSON.parse(JSON.stringify(res.data.rows)).forEach((item) => {
                let newObj = {}
                newObj.value = item.id
                newObj.label = item.name
                newdata.push(newObj)
                return newdata
            })
            this.selectList = newdata
        })

    }
    getSelectList2 = async () => {
        const res = await http.get(`/adminapi/systemmanagement?page=${this.page}&pagesize=${this.pagesize}&jrxtid=${this.jrxtid}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.xtmc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList2 = newdata
            })
        }
    }
    //数据获取
    res = ''
    getDataList = async (statusv, index = "one") => {
        if (index === "one") {
            this.res = await http.get('/adminapi/admin')
        } else {
            this.res = await http.get('/adminapi/admin', {
                params: {
                    filter: `{"status":"${statusv}"}`,
                }
            })
        }
        runInAction(() => {
            const newData = JSON.parse(JSON.stringify(this.res.data.rows)).map(item => {
                item.passworda = '*******'
                return item
            })
            this.dataList = newData
            this.total = this.res.data.total
        })
    }

    //删除
    getDeleteButtom = async (id) => {
        const res = await http.delete(`/adminapi/admin/${id}`)
        if (res.status) {
            this.getDataList()
        }
    }

    //添加
    getAddButtom = async (values) => {
        const res = await http.post(`/adminapi/admin`, values)
        console.log(res, "add")
        if (res.data.code === 400) {
            message.error(res.data.msg)
        } else {
            runInAction(() => {
                this.isActive = false
            })
            this.getDataList()
        }
    }

    //修改
    getPutInformation = async (values) => {
        const res = await http.put(`/adminapi/admin/${this.valueData.id}`, values)
        if (res.data.code === 400) {
            message.error(res.data.msg)
        } else {
            runInAction(() => {
                this.isActive = false
            })
            this.getDataList()
        }
    }

}

export { AuthorityStore }